import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSalespeople } from "@/hooks/useSalespeople";
import { UserRound } from "lucide-react";

export default function SalespersonSelect({ value, onChange, testid = "filter-salesperson" }) {
  const people = useSalespeople(true);
  return (
    <Select value={value || "all"} onValueChange={onChange}>
      <SelectTrigger className="h-11 w-full sm:w-56" data-testid={testid}>
        <UserRound className="h-4 w-4 text-slate-400 shrink-0" />
        <SelectValue placeholder="All salespeople" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="filter-salesperson-all">All salespeople</SelectItem>
        {people.map((p) => (
          <SelectItem key={p.id} value={p.id} data-testid={`filter-salesperson-${p.id}`}>
            {p.full_name}<span className="text-slate-400"> · {p.role_label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
